import { DigitalOceanCloudProvider } from "../providers/DigitalOceanWorker";
import * as NodeRSA from 'node-rsa';

const __rp = require('request-promise').defaults({json: true});     // tslint:disable-line
let rp;

export class DigitalOceanApi {

    private provider: DigitalOceanCloudProvider;
    private readonly stage = process.env.STAGE || "prod";

    constructor() {

    }

    public setProvider(provider: DigitalOceanCloudProvider) {
        this.provider = provider;
        rp = __rp.defaults({
            auth: { 'bearer': provider.credential },
            json: true
        })
    }

    public createDroplet(dropletTemplate: any): Promise<any> {
        return rp({
            uri: 'https://api.digitalocean.com/v2/droplets',
            method: 'POST',
            body: dropletTemplate
        })
    }

    public generateRandomSSHKey(): string {
        return "ssh-rsa AAAAB3NzaC1yc2EAAAADAQABAAABAQCsH+aIn7T6ylOvoOQnCl93sybhaW5UGKxHvbP1LjiUpJA26BU97/STm00YHCKfeFo/grCC0iRbrOIjAfRH+MWZ6WyI0hwiTbSfAAmvYa+EJBOeN97A/lCBUvJC/wsq9cGsHbfqqPLYxsAt94SzQCWV3PqsYyIQrGANsje2nWA5Oh/3GRZ3H8GGnhj00LJ9rMJSuUXc3aZhWaQotgXWMngjhFLUrsOUzllb34iWK6p1rSAM+SttjDBV92LU6d2Xzy36BQ8e28cY3ploG232Su6TN+I3iwXRWxJPM/AePFyV/6AOtNAWQry6mtvonn/y3Gr841IBc7LET3han49j3Fzv";
    }

    public async images(): Promise<any> {
        return rp("https://api.digitalocean.com/v2/images");
    }

    public async next(response): Promise<any> {
        return rp(response.links.pages.next);
    }

    // returns the key id
    public async uploadRandomKey(): Promise<number> {

        // Get the key if exists - otherwuse upload a random key
        const keyName = "porketta-test-random";
        const account = await rp("https://api.digitalocean.com/v2/account/keys");
        let key;
        if(account.ssh_keys) {
            key = account.ssh_keys.find(k => k.name === keyName);
            if(key) {
                return key.id;
            }
        }

        key = await rp({
            uri: 'https://api.digitalocean.com/v2/account/keys',
            method: 'POST',
            body: {
                name: keyName,
                public_key: this.generateRandomSSHKey()
            }
        });

        return Promise.resolve(key.id);

    }


}